import { render, staticRenderFns } from "./AmSynthEdit.vue?vue&type=template&id=1b05e945&scoped=true&"
import script from "./AmSynthEdit.vue?vue&type=script&lang=js&"
export * from "./AmSynthEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05e945",
  null
  
)

export default component.exports